/**
 * @file
 * This modal is just on EPC region. For TLD page, please check jnjethicon-localization-modal.es6.js
 */
(function ($, Drupal) {
  'use strict';

  var firstSelectVal;
  var secondSelectVal;
  var utils = Drupal.jnjethicon_product_localization_utils;
  var regionFromURL = Drupal.jnjethicon_product_localization_utils.getRegionFromURL();
  var currentCountry;

  // Disable continue button until selects are selected in modal.
  $('.jnjethicon-product-localizationmodal .localization-product-continue').addClass('disabled');
  // Add attribute in modal continue button for dismiss modal on click it.
  $('.jnjethicon-product-localizationmodal .localization-product-continue').attr('data-dismiss','modal');
  getSelectVal();

  // Check if change in first select modal.
  $('.jnjethicon-product-localizationmodal .localization-product-region').change(function() {
    getSelectVal();
    btnDisableEnable();
    var currentLang = utils.getParameterByName('lang');
    $.ajax({
      type: "GET",
      url: Drupal.url('jnjethicon_product_localization/get_countries_dropdown/' + firstSelectVal + '/' + currentLang),

      success: function(data) {
        // Remove previous element.
        $('.country-list').remove();
        var sel = $('#edit-country');
        $(data).each(function() {
          sel.append($('<option class="country-list">').attr('value',this.val).text(this.text));
        });
        $('#edit-country option[value=' + currentCountry + ']').attr('selected', 'selected');
        var selectedCountry = $('#edit-country').find(':selected').val();
        if (selectedCountry == 0) {
          $('.jnjethicon-product-localizationmodal .localization-product-continue').addClass('disabled');
        } else {
          $('.jnjethicon-product-localizationmodal .localization-product-continue').removeClass('disabled');
        }
      },

    });
  });

  // Check if change in second select modal.
  $('.jnjethicon-product-localizationmodal .localization-product-country').change(function() {
    getSelectVal();
    btnDisableEnable();

  });

  // Check the values select in modal.
  function getSelectVal() {
    firstSelectVal = $('.localization-product-region').val();
    secondSelectVal = $('.localization-product-country').val();

  }

  // Button enable or disable if selects are selected in modal.
  function btnDisableEnable() {
    if (firstSelectVal != 0 && secondSelectVal != 0 && firstSelectVal != null && secondSelectVal != null) {
      $('.localization-product-continue').removeClass('disabled');

    }
    else {
      $('.localization-product-continue').addClass('disabled');

    }

  }

  var EPCPage = $('.path-epc').length;
  var ProductPage = $('.page-node-type-products-and-specifications').length;

  if (EPCPage || ProductPage) {
    $('.localization-product-continue').addClass('disabled');

    // Check which text will be showed in modal with or not country name.
    $.ajax({
      type: "GET",
      url: Drupal.url('jnjethicon_product_localization/get_country'),

      success: function(data) {
        var country = '#jnjethicon-product-localizationmodal';

        if (data.country == 'RESERVED') {
          $('.localization-product-content.unknow-reserved').show();
          $('#edit-region option[value=0]').attr('selected', 'selected');
        }
        else {
          $('.localization-product-content.found-country').show();
          if (data.region_code) {
            $('#edit-region').val(data.region_code).change();
            currentCountry = data.redirect;
          }
        }
        $(country + ' .country').text(data.country);
        $(country).data('full_localization', data);
      },

    });
  }

  Drupal.behaviors.jnjethicon_product_localization_modal = {
    attach: function (context, drupalSettings) {

      var countryEPC = '#jnjethicon-product-localizationmodal';

      // Event to set cookie when the user clicks on red continue button.
      $('.localization-product-continue', context).click(function (event) {
        event.preventDefault();

        // Get full json from cookie.
        var full_localization = $(countryEPC).data('full_localization');
        var elemCountry = $(countryEPC + ' select[name="country"] option:selected');
        var elemRegion = $(countryEPC + ' select[name="region"] option:selected');
        var countryCodeFromUrl = Drupal.jnjethicon_product_localization_utils.getParameterByName('lang');

        // Call a route to get the correct redirect for the given region and
        // lang-country.
        $.ajax({
          type: "POST",
          url: Drupal.url('jnjethicon_product_localization/get_redirect/' + elemRegion.val() + '/' + elemCountry.val()),
          data: {regionName: elemRegion.val(), elemCountry: elemCountry.val()},

          success: function (data) {
            var selected_country_code = elemCountry.val();
            var selected_country_label = elemCountry.text();
            var selected_region_code = elemRegion.val();
            var selected_region_label = elemRegion.text();

            // Fill cookie when status is "RESERVED".
            if (selected_country_code != full_localization.redirect && (selected_country_code != null && selected_region_code != null)) {
              full_localization.redirect = selected_country_code;
              full_localization.country_select = selected_country_label;
              full_localization.region = selected_region_label;
              full_localization.region_code = selected_region_code;
              full_localization.country = selected_country_label;
            }

            Drupal.behaviors.jnjethicon_product_localization_control_query.init(full_localization.redirect);
            utils.setCookie('ethicon_epc_country', JSON.stringify(full_localization), parseInt(drupalSettings.jnjethicon_product_localization.cookie_lifespan));
            if (selected_country_code != countryCodeFromUrl || selected_region_code != regionFromURL) {
              window.location.href = '/' + data.redirect + '/epc?lang=' + full_localization.redirect;
            }
          }
        });
      });

      $(".jnjethicon-product-localizationmodal").on("hidden.bs.modal", function (event) {
        var $path = Drupal.behaviors.jnjethicon_common_utils.getPathName();
        // put your default event here
        event.preventDefault();
        utils.setCookie('ethicon_epc_modal_hide', '1', null, $path);
      });

      // We only show the modal if we don't have a cookie set.
      $('#block-ethiconproductlocalizationmodalblock', context).each(function () {
        // Check if the once flag is already set
        if ($(this).data('jnjethicon_localization')) {
          return;
        }
      
        // Set the once flag
        $(this).data('jnjethicon_localization', true);
      
        var redirect = utils.getCookie('ethicon_epc_country');
        var hideModal = utils.getCookie('ethicon_epc_modal_hide');
      
        if (!redirect && !hideModal) {
          // Opens the modal. Modal is using Bootstrap behavior.
          $(this).modal('show');
        }
      });
      
    }
  };

})(jQuery, Drupal);
